import {Component} from '@angular/core';

@Component({
    selector: 'app-finzy-gets-certificate',
    templateUrl: './finzy-gets-certificate.component.html',
    styleUrls: ['./article.component.css']
})

export class FinzyGetsCertificateComponent {
}